<template>
  <div id="userPreview">
    <el-dialog
      :visible.sync="modalStatus"
      top="8vh"
      @close="closedModal"
      width="595px"
    >
      <div class="rm-scrollbar" style="height: 847px; width: 595px">
        <member
          :userDetail="passData()"
          :powerData="powerData"
          :orgChartData="modalMemberData['org']"
          :modalMemberData="modalMemberData"
          :relationshipData="passProfileToRelationship"
        ></member>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";

export default {
  directives: {
    dragscroll,
  },
  name: "modal-preview-user",
  components: {
    loadingEven: require("../../even/loading").default,
    Member: require("@/components/content/user-profile-details").default,
    // relationshipMapping:
    //   require("../../members/members-components/relationship-mapping").default,
    // orgTab: require("../../members/members-components/org").default,
  },
  props: [
    "modalMemberData",
    "userDetail",
    "passProfileToRelationship",
    "showingModal",
    "userEmail",
  ],
  data() {
    return {
      modalStatus: this.showingModal,
      orgData: [],
      activeTab: "powers",
      // leaderboards: {
      //   dailyStreak: {
      //     value: 302,
      //     your: "1st",
      //     max: "42nd",
      //   },
      //   superFeedback: {
      //     value: 302,
      //     your: "160th",
      //     max: "188nd",
      //   },
      //   superRecog: {
      //     value: 26,
      //     your: "3td",
      //     max: "28nd",
      //   },
      //   optimism: {
      //     value: 456,
      //     your: "3td",
      //     max: "5nd",
      //   },
      // },
      // powerData: [
      //   {
      //     label: "Empathy",
      //     value: 4361,
      //     maxValue: 4590,
      //     icon: "ic_empathy",
      //   },
      //   {
      //     label: "Self-awareness",
      //     value: 3812,
      //     maxValue: 4590,
      //     icon: "ic_selfawareness",
      //   },
      //   {
      //     label: "Critical Thinking",
      //     value: 3212,
      //     maxValue: 4590,
      //     icon: "ic_criticalthinking",
      //   },
      //   {
      //     label: "Leadership",
      //     value: 1592,
      //     maxValue: 4590,
      //     icon: "ic_leadership",
      //   },
      //   {
      //     label: "Initiative-making",
      //     value: 1281,
      //     maxValue: 4590,
      //     icon: "ic_initiative",
      //   },
      //   {
      //     label: "Optimism",
      //     value: 456,
      //     maxValue: 4590,
      //     icon: "ic_optimism",
      //   },
      // ],
    };
  },
  watch: {
    showingModal() {
      this.modalStatus = this.showingModal;
    },
  },
  computed: {
    riskData() {
      return this.$store.getters["people/riskData"];
    },
    loadingLoadMoreData() {
      return this.$store.getters["people/loadingLoadMoreData"];
    },
    powerData() {
      return this.$store.getters["people/powerData"];
    },
  },
  created() {
    this.$store.dispatch("people/getRisk", this.userDetail);
    this.$store.dispatch("people/getStarPerformer", this.userDetail);
    this.$store.dispatch("people/getHoliday", this.userDetail);
    this.$store.dispatch("people/getDailyStatus", this.userDetail).then(() => {
      setTimeout(() => {
        var container = this.$el.querySelector("#riskBox");
        container.scrollLeft = container.scrollWidth;
      }, 1000);
    });
    this.$store.dispatch("people/getPowerData", this.userDetail);
  },
  mounted() {},
  methods: {
    getImgUrlMem(pic) {
      var images = require.context("@/assets/images/members/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgIconOfPower(name) {
      return require("@/assets/images/components/profile/" + name + ".png");
    },
    getImgUrlSet(pic) {
      var images = require.context(
        "@/assets/images/settings/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    closedModal() {
      if (this.showingModal) {
        this.$emit("closed", false);
      }
      this.$store.dispatch("people/clearDate");
    },
    loadMoreData() {
      this.$store.dispatch("people/getDailyStatus", this.userDetail);
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      let width = (450 / 100) * percentage;
      return width || "0";
    },
    passData() {
      const data = {...this.userDetail}
      // data.leaderboards = this.leaderboards;
      data.riskData = this.riskData;
      // data.topSkills = [
      //     {
      //       name: "Timely",
      //       value: 14,
      //     },
      //     {
      //       name: "Clarity",
      //       value: 13,
      //     },
      //     {
      //       name: "Leadership",
      //       value: 7,
      //     },
      //     {
      //       name: "Growth Mindset",
      //       value: 4,
      //     },
      //     {
      //       name: "Teamwork",
      //       value: 2,
      //     },
      //     {
      //       name: "Teamwork2",
      //       value: 1,
      //     },
      //   ];
      // data.cultureAdd = [
      //     {
      //       name: "#teamwork",
      //       value: 14,
      //     },
      //     {
      //       name: "#operationalexceeeeeeeeeee",
      //       value: 13,
      //     },
      //     {
      //       name: "#customer-centriiiiiiiiiiiii",
      //       value: 7,
      //     },
      //     {
      //       name: "#openness",
      //       value: 4,
      //     },
      //     {
      //       name: "#honesty",
      //       value: 2,
      //     },
      //     {
      //       name: "#honesty2222",
      //       value: 1,
      //     },
      //   ];
      // console.log(data);
      return data;
    }
  },
};
</script>

<style lang="scss" scoped>
#userPreview {
  font-family: 'Lato', 'Kanit', Arial, sans-serif;
}
.flex-column {
  word-break: normal;
}
.icon-close {
  position: absolute;
  right: 60px;
  top: 30px;
  font-size: 30px;
  opacity: 0.8;
  cursor: pointer;
  > i {
    position: fixed;
  }
}
</style>
<style lang="scss">
#userPreview {
  .el-dialog {
    max-width: 650px;
  }
  .el-dialog__header {
    padding: 0px;
    > button {
      opacity: 0;
    }
  }
  .el-dialog__body {
    padding: 0px;
    height: 847px;
  }
}
</style>